<template>
  <b-container>
    <h1>What are you after?</h1>
    <b-overlay :show="loading" opacity="0.6">
      <b-row>
        <b-col cols="12" sm="6" md="6" :key="index" v-for="(category, index) in categories">
          <div class="categories">
            <router-link :to="{path: '/sub-categories/' + category.id}" class="category-card with-bg shadow-lg"
                         :style="{'background-image': 'url(' + category.categoryImage + ')'}">
              <h2 class="title">{{ category.name }}</h2>
            </router-link>
          </div>
        </b-col>
      </b-row>

      <div v-if="updateMessage" class="app-update-noti">
        {{ updateMessage }}
      </div>
    </b-overlay>
  </b-container>
</template>

<script>
export default {
  name: "Categories",

  data() {
    return {
      loading: false,
      categories: [],
      updateMessage: ''
    }
  },

  mounted() {
    this.getCategories();
    this.checkVersion();
  },

  methods: {
    getCategories() {
      this.loading = true;
      axios.get('/item/categories').then(response => {
        this.categories = response.data;
        this.loading = false;
      })
    },
    checkVersion() {
      let self = this;
      cordova.getAppVersion.getVersionNumber().then(function (version) {
        axios.get('/checkCurrentVersion/' + version, {
          headers: {'Authorization': 'Bearer ' + localStorage.getItem('token')},
        }).then(response => {
          self.updateMessage = response.data.msg;
        })
      })
    },

  }
}
</script>

<style scoped>

</style>